export default {"src":"/_next/static/media/feature-3.0755173a.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};